import { boot } from '@dazn/bootstrap-lib';

import { Configuration } from '../global-modules';

import { getCountry } from './getCountry';

export const getChapterCountry = (
    currentPath: string,
    startupDataCountry: boot.config.AnyCountry,
    getIsPortable: () => boolean,
    chapterConfiguration: Configuration['chapters'],
    getChapterFromPath: (path: string) => boot.config.ChapterName | undefined,
    signupCountry: string,
    contentCountry: boot.config.AnyCountry | '',
) => {
    const currentChapter = getChapterFromPath(currentPath);
    const shouldGetCountryFromURL = currentChapter
        ? chapterConfiguration.getsCountryFromUrl(currentChapter)
        : false;
    const shouldUseSignUpCountry = currentChapter
        ? chapterConfiguration.useSignUpCountry(currentChapter)
        : false;
    const isPortable =
        currentChapter &&
        chapterConfiguration.usePortability(currentChapter) &&
        getIsPortable();

    return getCountry(
        startupDataCountry || '',
        signupCountry,
        shouldGetCountryFromURL ? currentPath : null,
        contentCountry,
        shouldUseSignUpCountry,
        isPortable || false,
    );
};
